<template>
    <div>
        <div class="topbar">
            <div class="tabs tabs-primary">
                <b-nav tabs>
                    <b-nav-item active>
                        Users Searches
                    </b-nav-item>

                    <b-nav-item href="/ai-response-history">
                        AI Responses
                    </b-nav-item>
                </b-nav>
            </div>
            <br>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="items"
                    :has-filters="true"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    v-on:changePage="changePage"
                    v-on:changeSort="changeSort"
                    v-on:changeFilters="changeFilters"
                    v-on:action="gridAction"
                >
                </Grid>
            </div>
        </div>

        <b-modal :hide-footer="true" id="rulesModal" modal-class="modal-w-xxl" title="User Search Rules">
            <div style="background-color: #043648; color: white; padding:20px; margin-bottom:20px;">
                <div class="mb-3">
                    Ai Mode: {{!!promptQuery ? 'On' : 'Off'}}
                </div>

                <PromptBar v-if="promptQuery"
                    :query="promptQuery"
                />

                <EquationBar
                    :query="query"
                />

                <a :href="`${mainDomain}/startups?search=${currentId}`" target="_blank">
                    Open in Search
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Grid from "../../../../../frontend/src/components/Grid.vue"
import grid from "../../../../../frontend/src/mixins/grid"
import usersSearchesService from "@/services/users-searches.service";
import EquationBar from '../../../../../frontend/src/components/search/EquationBar.vue';
import PromptBar from '../../../../../frontend/src/components/search/PromptBar.vue';

export default {
    components: {
        Grid,
        EquationBar,
        PromptBar
    },

    mixins: [grid],

    data() {
        return {
            query: {rules: []},
            promptQuery: {},
            currentId: null,

            columns: [
                {
                    label: 'Company Type',
                    name: 'company_type',
                    filter: 'single-select',
                    options: [
                        {
                            id: 'enterprise',
                            name: 'Enterprise'
                        },
                        {
                            id: 'ecosystem',
                            name: 'Ecosystem'
                        },
                        {
                            id: 'startup',
                            name: 'Startup'
                        },
                    ]
                },
                {
                    label: 'Company ID',
                    name: 'company_id',
                    filter: 'text',
                },
                {
                    label: 'Company Name',
                    name: 'company_name',
                    filter: 'text',
                },
                {
                    label: 'Account Type',
                    name: 'account_type',
                    filter: 'single-select',
                    options: [
                        {
                            id: 'free',
                            name: 'free'
                        },
                        {
                            id: 'paid',
                            name: 'paid'
                        },
                        {
                            id: 'test',
                            name: 'test'
                        },
                        {
                            id: 'pilot',
                            name: 'pilot'
                        },
                        {
                            id: 'trial',
                            name: 'trial'
                        },
                        {
                            id: 'invited',
                            name: 'invited'
                        },
                        {
                            id: 'standard',
                            name: 'standard'
                        },
                        {
                            id: 'premium',
                            name: 'premium'
                        },
                    ]
                },
                {
                    label: 'User',
                    name: 'email',
                    filter: 'text',
                },
                {
                    label: 'Results',
                    name: 'results',
                    sortable: true,
                },
                {
                    label: 'Boosted Startups',
                    name: 'boosted_startups',
                    component: 'RawColumn',
                },
                {
                    label: 'Created At',
                    name: 'created_at',
                    sortable: true,
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Link',
                }
            ],

            getListMethod: usersSearchesService.getSearches
        }
    },

    mounted() {
        this.getList()
    },

    provide() {
        return {
            fromAdmin: true
        }
    },

    methods: {
        gridAction(params) {
            if (params.action === 'view') {
                this.currentId = params.rowId;
                this.query.rules = JSON.parse(this.items.find(item => item.id === params.rowId).rules);
                this.promptQuery = JSON.parse(this.items.find(item => item.id === params.rowId).prompt_query);
                this.$bvModal.show('rulesModal')
            }
        },
    }
}
</script>

<style scoped>

</style>
